import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@opendate-app/setlist';

const ContactInfoForm = ({
  firstName,
  lastName,
  email,
  confirmEmail,
  onFirstNameChange,
  onLastNameChange,
  onEmailChange,
  onConfirmEmailChange,
  disabled = false,
  emailError = false,
  confirmEmailError = false
}) => {
  const emailsMatch = !confirmEmail || email === confirmEmail;

  return (
    <div className="row">
      <div className="col-12">
        <div className="form-row">
          <div className="col-12 col-sm-6 mb-3">
            <TextInput
              type="text"
              placeholder="First name"
              aria-label="First name"
              value={firstName || ""}
              disabled={disabled}
              onChange={onFirstNameChange}
            />
          </div>
          <div className="col-12 col-sm-6 mb-3">
            <TextInput
              type="text"
              placeholder="Last name"
              aria-label="Last name"
              value={lastName || ""}
              disabled={disabled}
              onChange={onLastNameChange}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col-6">
            <TextInput
              type="email"
              placeholder="Email address"
              aria-label="Email address"
              value={email || ""}
              disabled={disabled}
              onChange={onEmailChange}
              error={emailError ? <span /> : undefined}
            />
          </div>
          <div className="col-6">
            <TextInput
              type="email"
              placeholder="Confirm email"
              aria-label="Confirm email"
              value={confirmEmail || ""}
              disabled={disabled}
              onChange={onConfirmEmailChange}
              error={!emailsMatch || confirmEmailError ? <span /> : undefined}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ContactInfoForm.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  confirmEmail: PropTypes.string,
  onFirstNameChange: PropTypes.func.isRequired,
  onLastNameChange: PropTypes.func.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onConfirmEmailChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  emailError: PropTypes.bool,
  confirmEmailError: PropTypes.bool
};

export default ContactInfoForm;
